// extracted by mini-css-extract-plugin
export default {"Teams":"Teams_Teams__IQ5js","TeamTitle":"Teams_TeamTitle__vfcC1","TeamList":"Teams_TeamList__PrrI8"};